import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Playback speed on a Feedback Loop recording (Phelipe 2026-10-19: Chrome
// hides its own speed option in the player's ⋮ menu, and nobody finds it).
// Wrap a <video> in an element with this controller: a small 1× / 1.5× / 2×
// button sits on the video's top-right corner, and the choice is remembered
// for the next recording in this browser.
const SPEEDS = [1, 1.5, 2]
const KEY = "feedback_video_speed"

export default class extends Controller {
  static values = { title: { type: String, default: "Playback speed" } }

  connect() {
    this.video = this.element.querySelector("video")
    if (!this.video || this.element.querySelector("[data-video-speed]")) return
    this.speed = this._saved()
    this.btn = document.createElement("button")
    this.btn.type = "button"
    this.btn.dataset.videoSpeed = ""
    this.btn.title = this.titleValue
    this.btn.className = "absolute top-2 right-2 z-10 rounded-md text-white text-[13px] font-semibold px-2 py-0.5 cursor-pointer"
    this.btn.style.background = "rgba(17, 24, 39, 0.75)"
    this.btn.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); this._next() })
    this.element.appendChild(this.btn)
    this._apply = this._apply.bind(this)
    this.video.addEventListener("loadedmetadata", this._apply)
    this.video.addEventListener("play", this._apply)
    this._apply()
  }

  disconnect() {
    this.video?.removeEventListener("loadedmetadata", this._apply)
    this.video?.removeEventListener("play", this._apply)
  }

  _next() {
    this.speed = SPEEDS[(SPEEDS.indexOf(this.speed) + 1) % SPEEDS.length]
    try { localStorage.setItem(KEY, String(this.speed)) } catch { /* private window */ }
    this._apply()
    track("Feedback Video Speed Changed", { speed: this.speed })
  }

  _apply() {
    if (!this.video) return
    this.video.playbackRate = this.speed
    if (this.btn) this.btn.textContent = `${this.speed}×`
  }

  _saved() {
    try {
      const n = parseFloat(localStorage.getItem(KEY))
      return SPEEDS.includes(n) ? n : 1
    } catch {
      return 1
    }
  }
}
